"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTotalPopulation = void 0;

var useTotalPopulation = function useTotalPopulation(selectedSegments, populationData, isSuperSegment) {
  if (isSuperSegment === void 0) {
    isSuperSegment = false;
  }

  var total = 0;
  var resultsObj = {};

  if (populationData && populationData.length) {
    populationData.forEach(function (dataPoint) {
      // If we're looking at superSegment data & we haven't already got a
      // result for this dataPoint
      if (isSuperSegment && !resultsObj[dataPoint.segmentId]) {
        selectedSegments.forEach(function (selected) {
          // If the superSegment resides in the dataPoint, add it to results
          if (dataPoint.superSegmentIds.find(function (id) {
            return id === selected.id;
          })) {
            resultsObj[dataPoint.segmentId] = dataPoint;
          }
        }); // Just looking at single segments here
      } else {
        // If the selected segment is found in the populationData
        if (selectedSegments.find(function (selected) {
          return selected.id === dataPoint.segmentId;
        })) {
          // Add it to results
          resultsObj[dataPoint.segmentId] = dataPoint;
        }
      }
    });
  }

  Object.values(resultsObj).forEach(function (resultItem) {
    return total += resultItem.total;
  });
  return total;
};

exports.useTotalPopulation = useTotalPopulation;